import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Store, AppState, AppFields, take, switchMap } from '../store';

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(
    private store: Store<AppState>,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store.select(AppFields.App, AppFields.MyTeam).pipe(
      take(1),
      switchMap(team => {
        let newReq: HttpRequest<any> = req.clone();

        if (team && team.teamID) {
          newReq = req.clone({
            headers: req.headers.set('TeamID', team.teamID.toString())
          });
        }

        return next.handle(newReq);
      })
    );
  }
}
/*
export class InterceptorService implements HttpInterceptor {

  private apiUrl = 'https://api.dev.athleteone.com';

  constructor(
    private store: Store<AppState>,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store.select(AppFields.App, AppFields.MyTeam).pipe(
      take(1),
      switchMap(team => {
        let modifiedReq = req;

        // Replace relative URLs with full URL
        if (!req.url.startsWith('http')) {
          modifiedReq = req.clone({
            url: `${this.apiUrl}${req.url}`
          });
        }

        // Add custom header (e.g., TeamID)
        if (team && team.teamID) {
          modifiedReq = modifiedReq.clone({
            headers: modifiedReq.headers.set('TeamID', team.teamID.toString())
          });
        }

        return next.handle(modifiedReq);
      })
    );
  }
}
*/



// WEBPACK FOOTER //
// ./src/app/services/interceptor.service.ts